// extracted by mini-css-extract-plugin
export default {"previews":"tXEF6","landscape":"vlOIU","portrait":"k4Oj9","link":"XGLam","content":"GtlTm","galleryContainer":"kdx4N","gallery":"L9GTY","slide":"t8IPa"};